import http from '../../utils/http'

export const updateMyProfile = (data) => {
  return http.post('/api/User/UpdateMyProfile', data)
}

export const getUserInfo = () => {
  return http.get('/api/User/GetUser')
}
